import { render, staticRenderFns } from "./AiCustomerService.vue?vue&type=template&id=2d5acb9a&"
import script from "./AiCustomerService.vue?vue&type=script&lang=js&"
export * from "./AiCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports